package fr.frux.core.common.di

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.push.PushRegistrar
import fr.frux.core.common.push.PushTokenSink
import fr.frux.core.common.push.createPushRegistrar

/**
 * Module Metro du [PushRegistrar] (#252 P2), sur le modèle de `FileExporterModule`. Le [PushTokenSink]
 * est injecté et non construit ici : son implémentation vit dans `:shared` (elle parle à l'API), que
 * `core-common` ne peut pas voir.
 */
@ContributesTo(AppScope::class)
interface PushRegistrarModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun providePushRegistrar(sink: PushTokenSink): PushRegistrar = createPushRegistrar(sink)
    }
}
